export default __webpack_public_path__ + "static/media/survey-photography.fe608ca2.png";